import { render, staticRenderFns } from "./UsergroupsDetail.vue?vue&type=template&id=5e7abf8a&scoped=true"
import script from "./UsergroupsDetail.vue?vue&type=script&lang=js"
export * from "./UsergroupsDetail.vue?vue&type=script&lang=js"
import style0 from "./UsergroupsDetail.vue?vue&type=style&index=0&id=5e7abf8a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7abf8a",
  null
  
)

export default component.exports